module.exports = __webpack_public_path__ + "3983e483a59243cc78941b4d73bd84cd.png";